import { RawPatientsAges } from './types';
import { privateApi } from '../private-api';

export const chartsApi = privateApi.injectEndpoints({
	endpoints: (builder) => ({
		patientsAges: builder.query<RawPatientsAges[], null>({
			query() {
				return {
					url: 'report/charts/patients-ages',
					method: 'GET',
					credentials: 'include',
				};
			},

			transformResponse: (data: RawPatientsAges[]) =>
				data.slice().sort((a, b) => {
					const aMin = parseInt(a.ageGroup.split('-')[0], 10);
					const bMin = parseInt(b.ageGroup.split('-')[0], 10);
					return aMin - bMin;
				}),
		}),
		downloadPatientsAges: builder.query<Blob, void>({
			query: () => ({
				url: 'report/charts/patients-ages-report',
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
		downloadSubsectionReport: builder.query<Blob, void>({
			query: () => ({
				url: 'report/charts/subsections-report',
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
		downloadSectionReport: builder.query<Blob, void>({
			query: () => ({
				url: 'report/charts/sections-report',
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
		downloadSectionRatingsAvarageReport: builder.query<Blob, void>({
			query: () => ({
				url: 'report/charts/sections-average-ratings-report',
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
		downloadPerformanceSatisfactionChangesReport: builder.query<Blob, void>({
			query: () => ({
				url: 'report/charts/performance-satisfaction-changes-report',
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
		downloadMkfPrefixMentionsReport: builder.query<Blob, void>({
			query: () => ({
				url: 'report/charts/mkf-prefix-mentions-report',
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
		downloadMkfDomainMentionsReport: builder.query<Blob, void>({
			query: () => ({
				url: 'report/charts/mkf-domain-mentions-report',
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
		downloadPerGenderRegionReport: builder.query<Blob, void>({
			query: () => ({
				url: 'report/charts/gender-per-region-report',
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
		downloadChangelogReport: builder.query<Blob, void>({
			query: () => ({
				url: 'report/charts/changelog-report',
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
		downloadAllStatosticReport: builder.query<Blob, void>({
			query: () => ({
				url: 'report/charts/all-statistic-report',
				method: 'GET',
				responseHandler: (response) => response.blob(),
			}),
		}),
	}),
});
export const {
	usePatientsAgesQuery,
	useLazyDownloadSubsectionReportQuery,
	useLazyDownloadSectionReportQuery,
	useLazyDownloadMkfDomainMentionsReportQuery,
	useLazyDownloadMkfPrefixMentionsReportQuery,
	useLazyDownloadPerformanceSatisfactionChangesReportQuery,
	useLazyDownloadSectionRatingsAvarageReportQuery,
	useLazyPatientsAgesQuery,
	useLazyDownloadPatientsAgesQuery,
	useLazyDownloadPerGenderRegionReportQuery,
	useLazyDownloadChangelogReportQuery,
	useLazyDownloadAllStatosticReportQuery,
} = chartsApi;
